/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksLogic/ChallengeAuthorities/PlayCardDailyTripeaksAuthority',[
    'SolitaireShared/TriPeaksLogic/TriPeaksAuthority',
    'SolitaireShared/TriPeaksLogic/IDailyTripeaksAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/IPlayCardDailyAuthority',
    'SolitaireShared/CardLogic/CardOp'
], function (TriPeaksAuthority, IDailyTriPeaksAuthority, IDailyAuthority, IPlayCardDailyAuthority, CardOp) {
    "use strict";

    var PlayCardDailyTriPeaksAuthority = function (param) {
        this.initPlayCardDailyTriPeaksAuthority(param);
    };

    PlayCardDailyTriPeaksAuthority.constructor = PlayCardDailyTriPeaksAuthority;
    PlayCardDailyTriPeaksAuthority.prototype = Object.create(IDailyTriPeaksAuthority.prototype);
    IPlayCardDailyAuthority.call(PlayCardDailyTriPeaksAuthority.prototype);

    Object.defineProperty(PlayCardDailyTriPeaksAuthority.prototype, "NumberPlayed",  {
        get: function () {
            return this.CardPlayed() ? 1 : 0;
        }
    });

    PlayCardDailyTriPeaksAuthority.KeyCardToPlay =  "CARDTOPLAY";

    /// <summary>
    /// Constructs a daily challenge authority which implements the win condition "Play card x to foundation"
    /// </summary>
    /// <param name="param">String value of card which must be played</param>
    PlayCardDailyTriPeaksAuthority.prototype.initPlayCardDailyTriPeaksAuthority = function (param) {
        IDailyTriPeaksAuthority.call(this);
        this.SuppressBonusAnimations = true;

        if (param != null && param[PlayCardDailyTriPeaksAuthority.KeyCardToPlay])
            this._cardToPlay = this.GetCardValue(param[PlayCardDailyTriPeaksAuthority.KeyCardToPlay].toUpperCase());
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayCard;
        this.GoalCompleted = false;
    };

    PlayCardDailyTriPeaksAuthority.prototype.Deal = function () {
        this._goalCompleted = false;

        return IDailyTriPeaksAuthority.prototype.Deal.call(this);
    };


    PlayCardDailyTriPeaksAuthority.prototype.GetScoreForAction = function (action)
    {
        var botherChecking = false;
        for (var i = 0; i < action.Ops.length; i++)
        {
            var op = action.Ops[i];
            var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
            if (op.Opcode == CardOp.Op.Move && destPile.Type == "Waste" && !destPile.Empty)
            {
                botherChecking = true;
                break;
            }
        }

        if (botherChecking)
        {
            var cards = this.CardSupply.GetPile("Waste").GetCards();
            for (var ci = 0; ci < cards.length; ci++)
            {
                var card = cards[ci];
                if (card.ToString() == (this._cardToPlay))
                {
                    this._goalCompleted = true;
                    break;
                }
            }
        }

        return IDailyTriPeaksAuthority.prototype.GetScoreForAction.call(this, action);
    };


    PlayCardDailyTriPeaksAuthority.prototype.CardPlayed = function ()
    {
        for (var i = 0; i < 4; i++)
        {
            var pile = this.CardSupply.GetPile("Foundation" + i);
            if (!pile.Empty && pile.Top.ToString() == this._cardToPlay)
            {
                return true;
            }
        }

        return false;
    };

    PlayCardDailyTriPeaksAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.IsWaitingForAds)
        {
            return false;
        }
        return (!this.CardSupply.WaitingForAnimation) && this.GoalCompleted;
    };

    PlayCardDailyTriPeaksAuthority.prototype.GetHint = function (cycle, cheat)
    {
        if(cheat) {
            return IDailyTriPeaksAuthority.prototype.GetHint.call(this, cycle, cheat);
        }
        var numTableaus = 28;

        var hints = [];

        var a;
        this.CardSupply.GetPile("Foundation");
        var cards = [];
        cards.push("CHALLENGE");

        // Tableau-a-tableau matches first.
        for (var i = numTableaus - 1; i >= 0; i--)
        {
            a = this.CardSupply.GetPile("Tableau" + i);
            if (a.Empty)
                continue;

            // Shortcut if we find an unblocked King.
            if (a.Top.ToString().Equals(this._cardToPlay))
            {
                // Note: the actually legal move would be a-to-foundation
                // but the foundation is invisible in Pyramid.

                cards.push(a.Top.Sequence.toString());

                break;
            }
        }
        if (cards.Count > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };
/*
    PlayCardDailyTriPeaksAuthority.prototype.GetCardValue = function (card)
    {
        var value = parseInt(card.substring(0, 2));
        if (!isNaN(value))
        {
            return "T" + card[card.length - 1];
        }
        return card;
    };*/

    PlayCardDailyTriPeaksAuthority.prototype.GetCardValue = function (card)
    {
        return card;
    };

    return PlayCardDailyTriPeaksAuthority;


});
